import { getDayFromTimestamp, normalizeStringToDateObj } from '@/utils/common';

export const normalizeGetExtraAppointmentOptions = (appointmentOptions) => {
  if (appointmentOptions) {
    const appointmentOptionsNormalized = [];
    const disabledDays = [];
    const initialDate = new Date(appointmentOptions[0].day);
    const finalDate = new Date(
      appointmentOptions[appointmentOptions.length - 1].day
    );
    const currentDate = new Date(initialDate);
    while (currentDate <= finalDate) {
      const dateStr = currentDate.toISOString().split('T')[0];
      const searchedDate = appointmentOptions.find(
        (item) => item?.day.split('T')[0] === dateStr
      );
      if (searchedDate) {
        appointmentOptionsNormalized.push({
          day: normalizeStringToDateObj(searchedDate?.day),
          dayApi: searchedDate?.day,
          slots: searchedDate?.slots.map((slot) => {
            const { day: slotDay, start, end } = { ...slot };
            return {
              day: normalizeStringToDateObj(slotDay),
              start: getDayFromTimestamp(start),
              end: getDayFromTimestamp(end),
              dayApi: slotDay,
              startApi: start,
              endApi: end,
              slotId: `${slotDay}${start}`,
            };
          }),
        });
      } else {
        disabledDays.push(normalizeStringToDateObj(dateStr));
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    let [firstAvailableAppointment] = Array.isArray(
      appointmentOptionsNormalized
    )
      ? appointmentOptionsNormalized
      : [];
    const { slots } = { ...firstAvailableAppointment };
    const [slot] = Array.isArray(slots) ? slots : [];
    const { start, end, startApi, endApi, slotId } = { ...slot };
    firstAvailableAppointment = {
      ...firstAvailableAppointment,
      start,
      end,
      startApi,
      endApi,
      slotId,
    };
    return {
      appointmentOptionsNormalized,
      disabledDays,
      firstAvailableAppointment,
    };
  }
  return null;
};
